import React, { useState, useEffect } from 'react';

import TeamSelector from '../TeamSelector/TeamSelector';
import Loader from '../lib/components/Loader';

import underwhelmingGentsUtil from '../lib/underwhelmingGentsUtil';

import api from '../utils/api';

import constants from '../lib/constants';

const teams = constants.managerList;

const PLAYER_ASSET_TYPE = 'player';
const PICK_ASSET_TYPE = 'pick';
const FAAB_ASSET_TYPE = 'FAAB';

const Trade = ({ outgoingPicks, playerData }) => {
    const [selectedTeam1Id, updateSelectedTeam1Id] = useState(0);
    const [selectedTeam2Id, updateSelectedTeam2Id] = useState(1);

    const [loading, updateLoading] = useState(false);
    const [apiResponse, updateApiResponse] = useState(null);

    const [assetsToTrade, updateAssetsToTrade] = useState({ [selectedTeam1Id]: [], [selectedTeam2Id]: []});

    const [draftOrders, updateDraftOrders] = useState({});

    useEffect(() => {
        api.get('/api/v1/draft/orders')
            .then(({ data }) => {
                updateDraftOrders(data);
            })
            .catch(err => {
                console.error('Error fetching draft orders:', err);
            });
    }, []);

    const handleTeam1IdUpdate = ({ teamId: selectedTeamId }) => {
        const temp = assetsToTrade;
        delete temp[selectedTeam1Id];
        temp[selectedTeamId] = [];
        updateAssetsToTrade(temp);

        if( selectedTeamId !== selectedTeam2Id) {
            updateSelectedTeam1Id(selectedTeamId);
        }
    };
    
    const handleTeam2IdUpdate = ({ teamId: selectedTeamId }) => {
        const temp = assetsToTrade;
        delete temp[selectedTeam2Id];
        temp[selectedTeamId] = [];
        updateAssetsToTrade(temp);

        if( selectedTeamId !== selectedTeam1Id) {
            updateSelectedTeam2Id(selectedTeamId);
        }
    };
    
    const executeTrade = () => {
        const tradeData = { 
            [teams[selectedTeam1Id]]: assetsToTrade[selectedTeam1Id],
            [teams[selectedTeam2Id]]: assetsToTrade[selectedTeam2Id]
        };
        updateLoading(true);
        api.post('/api/v1/transactions/trade', { tradeAway: tradeData }).then((res) => {
            updateLoading(false);
            updateApiResponse({ res });
        }).catch(err => {
            updateLoading(false);
            updateApiResponse({ err });
            console.error(err);
        });
    };

    const checkboxChanged = (e) => { 
        const id = e.currentTarget.id;
        const checked = e.currentTarget.checked;
        const teamMakingTrade = teams.indexOf(id.split('-')[0]);

        const assetType = id.split('-')[1];
        const temp = assetsToTrade[teamMakingTrade];

        if (assetType === PLAYER_ASSET_TYPE) {
            const playerId = id.split('-')[2];
            if (checked) {
                temp.push(playerId);
                updateAssetsToTrade({ 
                    ...assetsToTrade,
                    [teamMakingTrade]: temp
                });
            } else {
                updateAssetsToTrade({
                    ...assetsToTrade,
                    [teamMakingTrade]: temp.filter(value => value !== playerId)
                });
            }

        } else if (assetType === PICK_ASSET_TYPE) {
            const pickId = id.split('-')[2];

            if (checked) {
                temp.push(pickId);
                updateAssetsToTrade({ 
                    ...assetsToTrade,
                    [teamMakingTrade]: temp
                });
            } else {
                updateAssetsToTrade({
                    ...assetsToTrade,
                    [teamMakingTrade]: temp.filter(value => value !== pickId)
                });
            }

        } else if (assetType === FAAB_ASSET_TYPE) {
            const [managerName, _faab, type, year] = id.split('-');
            const faabChecked = document.getElementById(`${managerName}-${FAAB_ASSET_TYPE}-check-${year}`).checked;
            const faabValue = document.getElementById(`${managerName}-${FAAB_ASSET_TYPE}-value-${year}`).value || 0;

            const faabKey = `${FAAB_ASSET_TYPE}_${year}_${faabValue}`;

            if (type === 'check') {
                if (faabChecked) {
                    temp.push(faabKey);
                    updateAssetsToTrade({ 
                        ...assetsToTrade,
                        [teamMakingTrade]: temp
                    });
                } else {
                    updateAssetsToTrade({
                        ...assetsToTrade,
                        [teamMakingTrade]: temp.filter(value => value !== faabKey)
                    });
                }
            } else if (faabChecked) {
                // we are updating the value now
                // remove the old key from temp
                const tempWithoutOldKey = temp.filter(value => !value.includes(`${FAAB_ASSET_TYPE}_${year}`));
                // add the new key to temp
                tempWithoutOldKey.push(faabKey);
                updateAssetsToTrade({
                    ...assetsToTrade,
                    [teamMakingTrade]: tempWithoutOldKey
                });
            }

        }
        else {
            console.error('something went wrong... not supposed to be here');
        }
    }

    const getCheckboxId = (id) => `${id}-check`;

    const Checkbox = (name, id) => {
        return (
            <div className="form-check" key={getCheckboxId(id)}>
                <input className="form-check-input" type="checkbox" id={getCheckboxId(id)} onChange={checkboxChanged}/>
                <label className="form-check-label">
                    {name}
                </label>
            </div>
        )
    };
    
    const assets = (managerName, teamId) => {
        const allPicks = underwhelmingGentsUtil.getAllPicks(outgoingPicks, managerName);

        return (
            <>
                <h4>{managerName} assets</h4>
                <form className='mb-5'>
                    <div className="mb-3 mt-3">
                        {playerData.filter(player => {return player.manager === managerName}).map(player => (
                            Checkbox(`${player.name}`, `${managerName}-${PLAYER_ASSET_TYPE}-${player.id}`)
                        ))}
                    </div>
                    <div>
                        {Object.keys(allPicks).map(pickYear => (
                            <div key={`${managerName}-${pickYear}`}>
                                {allPicks[pickYear].map((picksInRound, round) => {
                                    if (picksInRound.length) {
                                        const yearDraftOrder = draftOrders[pickYear]?.order;
                                        const yearIsProjected = draftOrders[pickYear]?.isProjected;
                                        return picksInRound.map(originalOwnerName => {
                                            const pickPosition = yearDraftOrder ? yearDraftOrder.indexOf(originalOwnerName) + 1 + round * 12 : null;
                                            const pickLabel = `${originalOwnerName} ${pickYear} ${round + 1}` + (pickPosition ? ` (${yearIsProjected ? 'projected ' : ''}pick #${pickPosition})` : '');
                                            return Checkbox(pickLabel, `${managerName}-${PICK_ASSET_TYPE}-${originalOwnerName}_${pickYear}_${round + 1}`);
                                        });
                                    }
                                })}
                            </div>
                        ))}
                    </div>
                    <div>
                        {constants.eligbleFAABYears.map(year => (
                            <>
                                <span>FAAB {year}</span>
                                <div className="d-flex flex-row">
                                    <input
                                        className='form-check-input'
                                        type="checkbox"
                                        id={`${managerName}-${FAAB_ASSET_TYPE}-check-${year}`}
                                        onChange={checkboxChanged}
                                    />
                                    <input 
                                        type="number" 
                                        id={`${managerName}-${FAAB_ASSET_TYPE}-value-${year}`} 
                                        className="form-control"
                                        disabled={assetsToTrade[teamId] ? assetsToTrade[teamId].findIndex(asset => asset.includes(`${FAAB_ASSET_TYPE}_${year}`)) > -1 ? false : true : true}
                                        // bad naming but whatever
                                        onChange={checkboxChanged}
                                    />
                                </div>
                            </>
                        ))}
                    </div>
                </form>
            </>
        )
    }

    return (
        <div id="tradeContainer">
            
            <h2>Make a Trade</h2>
            <h3>Team 1</h3>
            <TeamSelector
                teams={teams}
                handleTeamUpdate={handleTeam1IdUpdate}
                initialTeamId={selectedTeam1Id}
            />
            <h3>Team 2</h3>
            <TeamSelector
                teams={teams}
                handleTeamUpdate={handleTeam2IdUpdate}
                initialTeamId={selectedTeam2Id}
            />
            {assets(teams[selectedTeam1Id], selectedTeam1Id)}
            {assets(teams[selectedTeam2Id], selectedTeam2Id)}
            <h3>Summary</h3>
            {Object.keys(assetsToTrade).map(teamId => (
                <div key={teamId}>
                    <div>{`${teams[teamId]} is trading:`}</div>
                    <ul>
                        {assetsToTrade[teamId].map(asset => (
                            <li>{asset}</li>
                        ))}
                    </ul>
                </div>
            ))}
            <div className='d-grid gap-2'>
                <button className='btn btn-primary' onClick={executeTrade}>Execute Trade</button>
            </div>
            <div>
                {loading && <Loader/>}
            </div>
        </div>
    )
}

export default Trade;